import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import FloatingLanguageSwitcher from 'components/FloatingLanguageSwitcher';
import { ReactComponent as Logo } from 'assets/images/kealogo-text-bg.svg';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './AuthShell.module.scss';

const AuthShell = ({ title, description, children, loading }) => {
  const localizeMessage = useLocalizedMessage();

  return (
    <div className={styles.page} data-testid="auth-shell">
      <FloatingLanguageSwitcher />
      <main className={styles.card} aria-busy={loading ? 'true' : 'false'}>
        <section className={styles.formPanel}>
          <Logo className={styles.logo} role="img" aria-label="Kea Labs" />
          <div className={styles.formHeader}>
            <h1>{title}</h1>
            {description && <p>{description}</p>}
          </div>
          <div className={styles.formContent}>{children}</div>
        </section>

        {loading && (
          <div className={styles.loadingOverlay} role="status" aria-label={localizeMessage('common.loading')}>
            <CircularProgress size={32} />
          </div>
        )}
      </main>
    </div>
  );
};

AuthShell.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
};

AuthShell.defaultProps = {
  description: null,
  loading: false,
};

export default AuthShell;
